export default "__VITE_ASSET__0606c3d3__"